import { z } from 'zod'

import { type IPlace } from '../schema'
import { type ICompanyLiteData } from './company'
import { type IBasicDataUser } from './user'

export interface IAddressBook {
  address: IPlace
  company: ICompanyLiteData
  id: number
  name: string
  user: IBasicDataUser
}

export const addAddressToAddressBookSchema = z.object({
  city: z.string().min(2, { message: 'City is required' }),
  name: z.string().min(2, { message: 'Name is required' }),
  post_code: z.string().min(2, { message: 'Postcode is required' }),
  street: z.string().min(2, { message: 'Street is required' }),
  user_id: z.number().optional(),
})

export type AddAddressToAddressBook = z.infer<typeof addAddressToAddressBookSchema>
